import { GlobalConstants } from "../../../common/constants/global.constant";

export const countryConstants = [
    {
        CountryName: GlobalConstants.ALGERIA,
        nameInEng: 'Algeria'
    },
    {
        CountryName: GlobalConstants.ARGENTINA,
        nameInEng: 'Argentina'
    },
    {
        CountryName: GlobalConstants.AUSTRALIA,
        nameInEng: 'Australia'
    },
    {
        CountryName: GlobalConstants.AUSTRIA,
        nameInEng: 'Austria'
    },
    {
        CountryName: GlobalConstants.BELGIUM,
        nameInEng: 'Belgium'
    },
    {
        CountryName: GlobalConstants.BRAZIL,
        nameInEng: 'Brazil'
    },
    {
        CountryName: GlobalConstants.CANADA,
        nameInEng: 'Canada'
    },
    {
        CountryName: GlobalConstants.CHILE,
        nameInEng: 'Chile'
    },
    {
        CountryName: GlobalConstants.CHINA,
        nameInEng: 'Mainland China'
    },
    {
        CountryName: GlobalConstants.COLOMBIA,
        nameInEng: 'Colombia'
    },
    { 
        CountryName: GlobalConstants.CROATIA,
        nameInEng: 'Croatia' 
    }, 
    { 
        CountryName: GlobalConstants.CYPRUS,
        nameInEng: 'Cyprus' 
    },
    {
        CountryName: GlobalConstants.CZECH_REPUBLIC,
        nameInEng: 'Czech Republic'
    },
    {
        CountryName: GlobalConstants.DENMARK,
        nameInEng: 'Denmark'
    },
    {
        CountryName: GlobalConstants.EGYPT,
        nameInEng: 'Egypt'
    },
    {
        CountryName: GlobalConstants.ESTONIA,
        nameInEng: 'Estonia'
    },
    {
        CountryName: GlobalConstants.FINLAND,
        nameInEng: 'Finland'
    },
    {
        CountryName: GlobalConstants.FRANCE,
        nameInEng: 'France'
    },
    {
        CountryName: GlobalConstants.GERMANY,
        nameInEng: 'Germany'
    },
    {
        CountryName: GlobalConstants.GREECE,
        nameInEng: 'Greece'
    },
    {
        CountryName: GlobalConstants.HONG_KONG,
        nameInEng: 'Hong Kong (SAR)'
    },
    {
        CountryName: GlobalConstants.HUNGARY,
        nameInEng: 'Hungary'
    },
    {
        CountryName: GlobalConstants.ICELAND,
        nameInEng: 'Iceland'
    },
    {
        CountryName: GlobalConstants.INDIA,
        nameInEng: 'India'
    },
    {
        CountryName: GlobalConstants.INDONESIA,
        nameInEng: 'Indonesia'
    },
    {
        CountryName: GlobalConstants.IRELAND,
        nameInEng: 'Ireland'
    },
    {
        CountryName: GlobalConstants.ISRAEL,
        nameInEng: 'Israel'
    },
    {
        CountryName: GlobalConstants.ITALY,
        nameInEng: 'Italy'
    },
    {
        CountryName: GlobalConstants.JAPAN,
        nameInEng: 'Japan'
    },
    {
        CountryName: GlobalConstants.KAZAKHSTAN,
        nameInEng: 'Kazakhstan'
    },
    {
        CountryName: GlobalConstants.KENYA,
        nameInEng: 'Kenya'
    },
    {
        CountryName: GlobalConstants.KOREA,
        nameInEng: 'Korea'
    },
    {
        CountryName: GlobalConstants.LATVIA,
        nameInEng: 'Latvia'
    },
    {
        CountryName: GlobalConstants.LEBANON,
        nameInEng: 'Lebanon'
    },
    {
        CountryName: GlobalConstants.LITHUANIA,
        nameInEng: 'Lithuania'
    },
    {
        CountryName: GlobalConstants.MALAYSIA,
        nameInEng: 'Malaysia'
    },
    {
        CountryName: GlobalConstants.MEXICO,
        nameInEng: 'Mexico'
    },
    {
        CountryName: GlobalConstants.MOROCCO,
        nameInEng: 'Morocco'
    },
    {
        CountryName: GlobalConstants.NETHERLANDS,
        nameInEng: 'Netherlands'
    },
    {
        CountryName: GlobalConstants.NEW_ZEALAND,
        nameInEng: 'New Zealand'
    },
    {
        CountryName: GlobalConstants.NORWAY,
        nameInEng: 'Norway'
    },
    {
        CountryName: GlobalConstants.NIGERIA,
        nameInEng: 'Nigeria'
    },
    {
        CountryName: GlobalConstants.PAKISTAN,
        nameInEng: 'Pakistan'
    },
    {
        CountryName: GlobalConstants.PERU,
        nameInEng: 'Peru'
    },
    {
        CountryName: GlobalConstants.PHILIPPINES,
        nameInEng: 'Philippines'
    },
    {
        CountryName: GlobalConstants.POLAND,
        nameInEng: 'Poland'
    },
    {
        CountryName: GlobalConstants.PORTUGAL,
        nameInEng: 'Portugal'
    },
    {
        CountryName: GlobalConstants.ROMANIA,
        nameInEng: 'Romania'
    },
    {
        CountryName: GlobalConstants.RUSSIA,
        nameInEng: 'Russia'
    },
    {
        CountryName: GlobalConstants.SAUDI_ARABIA,
        nameInEng: 'Saudi Arabia'
    },
    {
        CountryName: GlobalConstants.SLOVAKIA,
        nameInEng: 'Slovakia'
    },
    {
        CountryName: GlobalConstants.SINGAPORE,
        nameInEng: 'Singapore'
    },
    {
        CountryName: GlobalConstants.SOUTH_AFRICA,
        nameInEng: 'South Africa'
    },
    {
        CountryName: GlobalConstants.SPAIN,
        nameInEng: 'Spain'
    },
    {
        CountryName: GlobalConstants.SRI_LANKA,
        nameInEng: 'Sri Lanka'
    },
    {
        CountryName: GlobalConstants.SWEDEN,
        nameInEng: 'Sweden'
    },
    {
        CountryName: GlobalConstants.SWITZERLAND,
        nameInEng: 'Switzerland'
    },
    {
        CountryName: GlobalConstants.TAIWAN,
        nameInEng: 'Taiwan'
    },
    {
        CountryName: GlobalConstants.THAILAND,
        nameInEng: 'Thailand'
    },
    {
        CountryName: GlobalConstants.TURKEY,
        nameInEng: 'Turkey'
    },
    {
        CountryName: GlobalConstants.UKRAINE,
        nameInEng: 'Ukraine'
    },
    {
        CountryName: GlobalConstants.UNITED_ARAB_EMIRATES,
        nameInEng: 'United Arab Emirates'
    },
    {
        CountryName: GlobalConstants.UNITED_KINGDOM,
        nameInEng: 'United Kingdom'
    },
    {
        CountryName: GlobalConstants.UNITED_STATES,
        nameInEng: 'United States'
    },
    {         
        CountryName: GlobalConstants.URUGUAY,
        nameInEng: 'Uruguay'
    },
    {
        CountryName: GlobalConstants.VIETNAM,
        nameInEng: 'Vietnam'
    }

];
